import React from "react";
import { Container, Typography, Box, Button, Link } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { useNavigate } from "react-router-dom";

const CheckEmail = () => {
    const navigate = useNavigate();
  return (
    <Container sx={{ marginTop: 8 }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "100%",
          maxWidth: "400px",
          margin: "auto",
        }}
      >
        <Box
          sx={{
            width: "100%",
            maxWidth: 400,
            textAlign: "center",
            marginBottom: 4,
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          <img
            src="resolve_logo.png"
            alt="Logo"
            style={{ width: 60, height: 60, marginBottom: 16 }}
          />
        </Box>
        <Typography
          variant="h4"
          sx={{
            fontWeight: 600,
            fontStyle: "normal",
            fontFamily: "var(--Font-1)",
            color: "var(--Gray-900, #101828)",
            marginBottom: "16px",
            fontSize: "30px",
          }}
        >
          Check your email
        </Typography>
        <Typography
          variant="body1"
          sx={{
            fontFamily: "var(--Font-1)",
            color: "var(--Gray-700, #344054)",
            textAlign: "center",
            marginBottom: "32px",
          }}
        >
          We sent a password reset link to
          <br /> 
          your@email.com
        </Typography>
        <Button
        onClick={() => {navigate("/set_new_password")}} //for testing only, actually this should open email app and not navigate to set_new_password
          variant="contained"
          fullWidth
          sx={{
            background: "linear-gradient(90deg, #AD2B45 0%, #0084D1 100%)",
            borderRadius: "8px",
            height: "50px",
            fontWeight: 700,
            textTransform: "none",
            marginBottom: "32px",
          }}
        >
          Open email app
        </Button>
        <Link
          href="#"
          sx={{
            display: "flex",
                alignItems: "center",
                gap: 1,
                color: "var(--Gray-700, #344054)",
                textDecoration: "none",
                fontWeight: 600,
                fontSize: "14px",
                marginBottom: "32px",
          }}
        >
          Didn't receive the email? <Link href="#" >Click to resend</Link>
        </Link>
        <Link
            href="/login"
            sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                color: "var(--Gray-700, #344054)",
                textDecoration: "none",
                fontWeight: 600,
                fontSize: "14px",
            }}
            >
            <ArrowBackIosNewIcon fontSize="" />
            Back to log in
            </Link>
      </Box>
    </Container>
  );
};

export default CheckEmail;
